import React from 'react';

const VARIANTS = {
  danger: { bg: 'bg-red-100', iconColor: 'text-red-600', btnClass: 'bg-red-600 hover:bg-red-700 text-white' },
  warning: { bg: 'bg-amber-100', iconColor: 'text-amber-600', btnClass: 'bg-amber-600 hover:bg-amber-700 text-white' },
  info: { bg: 'bg-blue-100', iconColor: 'text-blue-600', btnClass: 'btn-primary' },
};

const ICONS = {
  delete: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />,
  warning: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4.5c-.77-.833-2.694-.833-3.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />,
  reject: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />,
};

const ConfirmModal = ({
  open,
  onClose,
  onConfirm,
  title = 'Are you sure?',
  message = '',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'danger',
  icon = 'warning',
  loading = false,
}) => {
  if (!open) return null;

  const v = VARIANTS[variant] || VARIANTS.danger;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 max-w-sm w-full mx-4 shadow-2xl">
        <div className="flex flex-col items-center text-center">
          <div className={`w-14 h-14 rounded-full ${v.bg} flex items-center justify-center mb-4`}>
            <svg className={`w-7 h-7 ${v.iconColor}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {ICONS[icon] || ICONS.warning}
            </svg>
          </div>
          <h3 className="text-lg font-bold text-dark-900 mb-2">{title}</h3>
          {message && <p className="text-sm text-dark-500 mb-6 leading-relaxed">{message}</p>}
        </div>
        <div className="flex gap-3">
          <button
            onClick={onClose}
            disabled={loading}
            className="flex-1 px-4 py-2.5 border border-dark-200 rounded-lg hover:bg-dark-50 text-sm font-medium text-dark-700 disabled:opacity-50"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className={`flex-1 px-4 py-2.5 rounded-lg text-sm font-medium disabled:opacity-50 ${v.btnClass}`}
          >
            {loading ? 'Processing...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
